<template>
  <div
    class="teamDetail_playerList"
    :style="{
      '--mixtmt_playerList_floor2Bg': `url('/static/${currThemeObj.sportType}/${currThemeObj.imageUrl}/playerList_floor2Bg.png')`,
    }"
  >
    <div
      class="player_item"
      v-for="item in list"
      :key="item.id"
      @click="
        goDetail(`playerDetailIndex_${currThemeObj.moduleRouteNameEn}`, item)
      "
    >
      <span class="playerItem_floor1">
        <span class="floor1_text" v-text="item.floor1_title"></span>
      </span>
      <span class="playerItem_floor2">
        <span class="floor2_image" :class="item.floor2_image ? 'isLogo' : ''">
          <img :src="item.floor2_image" />
        </span>
        <span class="floor2_bg"></span>
        <span class="floor2_textArea">
          <span class="textArea_No" v-text="item.floor2_no"></span>
          <span class="textArea_position" v-text="item.floor2_pos"></span>
          <span
            class="textArea_status"
            :class="item.floor2_status ? 'show' : ''"
            v-text="item.floor2_status"
          ></span>
        </span>
      </span>
      <span class="playerItem_floor3">
        <span class="floor3_row" v-for="row in item.floor3_list" :key="row.key">
          <span class="floor3_row_key" v-text="row.name"></span>
          <span class="floor3_row_val" v-text="row.val"></span>
        </span>
      </span>
    </div>
  </div>
</template>

<script>
import cup_base_data_mixin from '@mixins/cup_base_data'
export default {
  name: 'teamDetail_playerList',
  mixins: [cup_base_data_mixin],
  props: {
    list: {
      type: Array,
      default: () => {
        return [
          // {
          //   id: 1,
          //   floor1_title: '12312',
          //   floor2_image: '',
          //   floor2_no: 12,
          //   floor2_pos: '守门员',
          //   floor2_status: '大名单',
          //   floor3_list: [
          //     {
          //       key: 'asd',
          //       name: '出场',
          //       val: 3,
          //     },
          //     {
          //       key: 'asd1',
          //       name: '扑救',
          //       val: 3,
          //     },
          //     {
          //       key: 'asd2',
          //       name: '扑救成功',
          //       val: 3,
          //     },
          //   ],
          // },
        ]
      },
    },
  },
  data() {
    return {}
  },
  methods: {
    goDetail(routerName, item) {
      let query = {
        cid: this.currCid,
        sid: this.currSid,
        tid: item.tid,
        pid: item.pid,
      }
      this.pageJump(this.$router, routerName, query)
    },
  },
}
</script>

<style lang="scss" scoped>
.teamDetail_playerList {
  display: flex;
  display: -webkit-flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
  width: 100%;
  height: auto;

  .player_item {
    margin: 1.38vw 1.38vw 0 0;
    width: calc((100% - (1.38vw * 3)) / 4);
    height: auto;
    border: 1px solid var(--mixtmt_greyColor7);
    color: var(--mixtmt_greyColor3);
    &:nth-child(4n) {
      margin: 1.38vw 0 0 0;
    }
    .playerItem_floor1 {
      display: flex;
      display: -webkit-flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      height: 2.778vw;
      padding: 0 0.625vw 0 1.04vw;
      .floor1_text {
        font-size: 1.11vw;
        font-weight: bold;
      }
      .floor1_icon {
        &::before {
          font-size: 1.11vw;
          color: var(--mixtmt_blackColor);
        }
      }
    }
    .playerItem_floor2 {
      display: block;
      position: relative;
      padding-top: 48.18%;
      width: 100%;
      .floor2_image {
        display: block;
        position: absolute;
        top: 0;
        right: 0;
        z-index: 2;
        width: 37%;
        height: 100%;
        background-image: var(--mixtmt_default_playerLogo);
        background-repeat: no-repeat;
        background-size: auto 100%;
        background-position: center bottom;
        &.isLogo {
          background-image: none;
          /* background-color: rgba(238,238,229,1); */
          img {
            object-fit: cover;
          }
        }
        img {
          display: block;
          width: 100%;
          height: 100%;
          object-fit: contain;
        }
      }
      .floor2_bg {
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 4;
        width: 70.55%;
        height: 100%;
        background-image: var(--mixtmt_playerList_floor2Bg);
        background-size: 100% 100%;
        background-position: left top;
        background-repeat: no-repeat;
        object-fit: contain;
      }
      .floor2_textArea {
        display: flex;
        display: -webkit-flex;
        justify-content: flex-start;
        align-items: flex-start;
        flex-direction: column;
        position: absolute;
        top: 0;
        left: 0;
        z-index: 10;
        padding: 0.972vw 0 0 1.04vw;
        width: 70.55%;
        height: 100%;
        color: var(--mixtmt_whiteColor);
        span {
          font-size: 0.972vw;
          line-height: 2.083vw;
        }
        .textArea_status {
          position: relative;
          margin-top: 0.425vw;
          padding: 0 0.278vw;
          line-height: 1.666vw;
          &::before {
            content: '';
            position: absolute;
            left: 0;
            top: 0;
            z-index: 2;
            width: 100%;
            height: 100%;
            border: 1px solid var(--mixtmt_whiteColor);
            border-radius: 0.278vw;
          }
          &.show::before {
            content: '\20';
          }
        }
      }
    }
    .playerItem_floor3 {
      width: 100%;
      height: auto;
      .floor3_row {
        display: flex;
        display: -webkit-flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        padding: 0 1.388vw;
        height: 3.472vw;
        border-bottom: 1px solid var(--mixtmt_greyColor7);
        &:last-child {
          border-bottom: none;
        }
        span {
          font-size: 0.972vw;
        }
      }
    }
  }
}
.mixtmt_pc .teamDetail_playerList {
  .player_item {
    cursor: pointer;
    &:hover {
      border: 1px solid var(--mixtmt_mainColor3);
      box-shadow: 0.2vw 0.2vw 0.972vw 0.486vw rgba(60, 59, 59, 0.15);
    }
  }
}
</style>
